module.exports = __webpack_public_path__ + "static/media/w_b_35.735d94f6.png";